module.exports = __webpack_public_path__ + "media/images/thumbs/physanims/a8-0-d9e640431c235fe64d29a6f77c6c59d8.jpg";